import type { Event } from 'models';
import { Modal } from 'ui';
import type { SlotStart } from 'features/calendar';
import { CreateEventForm } from './create-event-form';

type P = {
  isOpened: boolean;
  onCancel: () => void;
  onSuccess: (eventData: Event) => void;
  slotStart?: SlotStart;
};

const CreateEventModal = ({ isOpened, onCancel, onSuccess, slotStart }: P) => (
  <Modal isOpened={isOpened} onCancel={onCancel} title="Create Event" width="large">
    <Modal.HugContent>
      <CreateEventForm onCancel={onCancel} onSuccess={onSuccess} slotStart={slotStart} />
    </Modal.HugContent>
  </Modal>
);

export default CreateEventModal;
